import { LoadingOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Button, Checkbox, Col, Input, Row, Space } from 'antd'
import FormItem from 'components/FormItem'
import { FacebookIcon, GoogleIcon } from 'components/Icons'
import Link from 'next/link'
import { StyledForm, StyledFormWrapper } from '../styles'
import validations from './validations'
// import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import FacebookLogin from 'react-facebook-login'
import GoogleLogin from 'react-google-login'
import PropTypes from 'prop-types'

export default function LoginForm({
  handleLogin,
  form,
  loginStateV2,
  handleLoginGoogle,
  handleLoginFacebook,
  agreeToShare,
  accSharingModalVisible,
  passwordStatus,
  checkIfPasswordIsUpdated,
  cancelCurrentLogin,
  mandatoryUpdate,
  verifyEmailState,
  forceResetOtpState,
  accountInactive,
  ...pageProps
}) {
  return (
    <StyledFormWrapper>
      <img
        className="mr-peri"
        alt="MR. PERI"
        draggable="false"
        src="/images/auth-assets/mr-peri.png"
      />
      <h1>Login to</h1>
      <img
        style={{ marginBottom: 38 }}
        src="/images/logos/peri-peri-orange.png"
        alt=""
      />
      <p className="new-user">
        New User?
        <Link href="/auth/register">
          <a style={{ marginLeft: 5 }}>Create an account</a>
        </Link>
      </p>
      <StyledForm
        form={form}
        initialValues={{
          remember: true,
          username:
            typeof window !== 'undefined'
              ? sessionStorage.getItem('loginEmail')
              : ''
        }}
        onFinish={(value) => {
          if (passwordStatus === 'verify') {
            checkIfPasswordIsUpdated(value)
          } else {
            handleLogin(value)
          }
        }}
      >
        <FormItem
          form={form}
          name="username"
          label="Email address"
          required
          rules={validations.email}
          hasFeedback
          disabled={passwordStatus === 'login'}
        >
          {(props) => (
            <div style={{ position: 'relative' }}>
              <Input {...props} />
              {passwordStatus === 'login' && (
                <Button
                  type="text"
                  style={{
                    position: 'absolute',
                    right: 0,
                    top: '-40%',
                    transform: 'translateY(-50%)',
                    zIndex: 5,
                    cursor: 'pointer',
                    pointerEvents: 'auto',
                    background: 'transparent',
                    border: 'none',
                    boxShadow: 'none'
                  }}
                  className="no-hover"
                  variant="text"
                  icon={<img src="/images/edit-icon.png" alt="" />}
                  onClick={cancelCurrentLogin}
                />
              )}
            </div>
          )}
        </FormItem>
        {passwordStatus === 'login' && (
          <FormItem
            form={form}
            label="Password"
            name="password"
            rules={validations.password}
          >
            {(props) => <Input.Password {...props} />}
          </FormItem>
        )}
        <Button
          disabled={
            loginStateV2.status === 1 ||
            forceResetOtpState.status === 1 ||
            verifyEmailState.status === 1
          }
          type="primary"
          block
          htmlType="submit"
        >
          Login{' '}
          {(loginStateV2.status === 1 ||
            verifyEmailState.status === 1 ||
            forceResetOtpState.status === 1 || verifyEmailState.status === 1) && <LoadingOutlined />}
        </Button>
        <Row
          className="below-fields"
          style={{ marginTop: 15 }}
          justify="space-between"
        >
          <Col span={12}>
            <Checkbox>Keep me logged in</Checkbox>
          </Col>
          <Col style={{ textAlign: 'right' }} span={12}>
            <Link href="/auth/forgot-password">Forgot Password?</Link>
          </Col>
        </Row>
        <Row
          justify="center"
          align="middle"
          style={{ textAlign: 'center' }}
        >
          <Col span={6}>
            <div className="divider" />
          </Col>
          <Col span={12}>
            <h2 style={{ color: 'var(--cognac)' }}>Login with</h2>
          </Col>
          <Col span={6}>
            <div className="divider" />
          </Col>
        </Row>
        <Row className="social-auth" justify="center" align="middle">
          <Col className="text-center" xs={{ span: 0 }} md={{ span: 24 }}>
            <Space size={20} direction="horizontal">
              <FacebookLogin
                appId={
                  pageProps?.clientSideKeys
                    ?.NEXT_PUBLIC_SOCIAL_AUTH_FACEBOOK_KEY
                }
                autoLoad={false}
                callback={handleLoginFacebook}
                fields="id,name,email,picture.type(large)"
                disableMobileRedirect={true}
                icon={<FacebookIcon />}
                textButton="Facebook"
                cssClass="social-media-btn"
              />
              <GoogleLogin
                clientId={
                  pageProps?.clientSideKeys
                    ?.NEXT_PUBLIC_SOCIAL_AUTH_GOOGLE_OAUTH2_KEY
                }
                render={(renderProps) => (
                  <Button
                    className="social-media-btn"
                    icon={<GoogleIcon />}
                    {...renderProps}
                  >
                    Google
                  </Button>
                )}
                onSuccess={handleLoginGoogle}
                onFailure={handleLoginGoogle}
                cookiePolicy={'single_host_origin'}
              />
            </Space>
          </Col>
          <Col className="text-center" xs={{ span: 24 }} md={{ span: 0 }}>
            <Row justify="center">
              <FacebookLogin
                appId={
                  pageProps?.clientSideKeys
                    ?.NEXT_PUBLIC_SOCIAL_AUTH_FACEBOOK_KEY
                }
                autoLoad={false}
                callback={handleLoginFacebook}
                fields="id,name,email,picture.type(large)"
                disableMobileRedirect={true}
                icon={<FacebookIcon />}
                textButton=""
                cssClass="social-media-btn"
              />
              <GoogleLogin
                clientId={
                  pageProps?.clientSideKeys
                    ?.NEXT_PUBLIC_SOCIAL_AUTH_GOOGLE_OAUTH2_KEY
                }
                onSuccess={handleLoginGoogle}
                render={(renderProps) => (
                  <Button
                    className="social-media-btn"
                    icon={<GoogleIcon />}
                    {...renderProps}
                  />
                )}
              />
            </Row>
          </Col>
        </Row>
      </StyledForm>
    </StyledFormWrapper>
  )
}

LoginForm.propTypes = {
  handleLogin: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  loginStateV2: PropTypes.shape({
    status: PropTypes.number
  }).isRequired,
  handleLoginGoogle: PropTypes.func.isRequired,
  handleLoginFacebook: PropTypes.func.isRequired,
  agreeToShare: PropTypes.func.isRequired,
  accSharingModalVisible: PropTypes.bool.isRequired,
  passwordStatus: PropTypes.string,
  checkIfPasswordIsUpdated: PropTypes.func.isRequired,
  cancelCurrentLogin: PropTypes.func.isRequired,
  mandatoryUpdate: PropTypes.bool,
  verifyEmailState: PropTypes.shape({
    status: PropTypes.number
  }).isRequired,
  forceResetOtpState: PropTypes.shape({
    status: PropTypes.number
  }).isRequired,
  accountInactive: PropTypes.bool,
  clientSideKeys: PropTypes.shape({
    NEXT_PUBLIC_SOCIAL_AUTH_FACEBOOK_KEY: PropTypes.string,
    NEXT_PUBLIC_SOCIAL_AUTH_GOOGLE_OAUTH2_KEY: PropTypes.string
  })
}

LoginForm.defaultProps = {
  isPasswordUpdated: false,
  mandatoryUpdate: false,
  accountInactive: false
}
